import useSWR from 'swr';
import { createRestApiClient } from '..';
import { all_count } from '../../components/Search/constants';

import { fireEvent } from '../../Utils/fireEvent';
import { getWebUserType } from '../../Utils/getWebUserType';
const restApiClient = createRestApiClient();

export const getSearchQueryResult = async (q, filter, start) => {
  const restApiClient = createRestApiClient();

  const paramObject = {
    q,
    filter: filter || 'all',
    rows: filter === 'all' ? all_count : 40,
    start: start || 0,
    userType: getWebUserType()
  };
  const url = `api/searchQuery`;
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
      params: paramObject,
    })
    .then((res) => res.data)
    .catch((err) => {
      fireEvent({
        category: 'api_error',
        error: err?.message,
        req: err?.config?.url,
      });
    });
  return data;
};
export const getAutoCompleteKeywords = async (query, filter) => {
  const params = {
    filter,
    q: query,
  };
  const url = `api/getAutoCompleteKeywords`;
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
      params: params,
    })
    .then((res) => res.data)
    .catch((err) => {
      fireEvent({
        category: 'api_error',
        error: err?.message,
        req: err?.config?.url,
      });
    });
  return data;
};
export function useGetSearchResultData(initialData, query, filter) {
  const options = {
    fallbackData: { data: undefined },
    revalidateIfStale: false,
    revalidateOnMount: false,
    revalidateOnFocus: false,
  };
  if (!initialData) {
    delete options.initialData;
  }
  let obj = query + (filter || '');
  const { data, error, mutate } = useSWR(
    `api/searchQuery/${obj}`,
    () => {
      getSearchQueryResult(query, filter);
    },
    options,
  );
  return {
    searchData: data.data ? JSON.parse(JSON.stringify(data.data)) : undefined,
    searchDataLoading: !error && !data,
    searchDataError: error,
    searchMutate: mutate,
  };
}

export const getTrendingSearches = async () => {
  const url = `api/getTrendingSearch`;
  const restApiClient = createRestApiClient();
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
    })
    .then((res) => res.data);
  return data;
};
export const useGetTagData = (query, filter) => {
  const options = {
    fallbackData: { data: undefined },
    revalidateIfStale: false,
    revalidateOnMount: false,
    revalidateOnFocus: false,
  };
  let obj = query + filter || '';
  const { data, error, mutate } = useSWR(
    `api/searchQueryAllData/${obj}`,
    () => {},
    options,
  );
  return {
    searchTagsData: data.data
      ? JSON.parse(JSON.stringify(data.data))
      : undefined,
    searchDataLoading: !error && !data,
    searchDataError: error,
    searchTagMutate: mutate,
  };
};
